<template>
    <v-card>
        <v-toolbar flat dense color="white lighten-2">
            <v-toolbar-title>Palety</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="8">
                    <v-text-field
                        ref="palletNumberField"
                        v-model="pallet"
                        clearable
                        label="Numer palety"
                        hint="Wpisz lub zeskanuj numer palety"
                        outlined
                        dense
                        :error-messages="palletErrors"
                        autofocus
                        @input="$v.pallet.$touch()"
                    />
                </v-col>
                <v-col>
                    <v-btn
                        color="success"
                        data-sentry-label="Dodaj numer palety"
                        :disabled="$v.pallet.$invalid"
                        @click="addPalletToList(pallet)"
                    >
                        <span> Dodaj </span>
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="allPallets"
                :mobile-breakpoint="0"
                hide-default-footer
            >
                <template #item.parameter="{item}">
                    {{ item.parameter }}
                </template>
                <template #item.details="{item}">
                    <v-tooltip :open-delay="tooltipDelay" top>
                        <template #activator="{on}">
                            <v-btn
                                icon
                                data-sentry-label="Usuń paletę"
                                v-on="on"
                                @click="removePallet(item)"
                            >
                                <v-icon color="pink">
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Usuń</span>
                    </v-tooltip>
                </template>
                <template slot="no-results">
                    <p class="text-center">
                        Brak danych
                    </p>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'PaperPalletReport',
    mixins: [
        pagination,
        dateFormatter,
        tooltipDelay,
    ],
    props: {
        palletsList: {
            type: Array,
            default: () => []
        },
        reportId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            allPallets: [],
            headers: [
                {
                    text: 'Numer palety',
                    value: 'parameter',
                    sortable: false,
                    width: 300,
                },
                {
                    text: 'Akcje',
                    value: 'details',
                    sortable: false,
                    align: 'center'
                }
            ],
            pallet: null,
        }
    },
    validations() {
        return {
            pallet: {
                required,
                isCorrectPallet: value => {
                    return /\.CF$/.test(value)
                }
            }
        }
    },
    computed: {
        lastPallet() {
            return this.allPallets.length === 1
        },
        palletErrors() {
            const errors = []

            if (!this.$v.pallet.$dirty) return errors
            !this.$v.pallet.required && errors.push('Kod palety jest wymagany.')
            !this.$v.pallet.isCorrectPallet && errors.push('Podany kod jest nieprawidłowy')

            return errors
        },
    },
    watch: {
        palletsList(newValue) {
            this.allPallets = newValue
        },
    },
    methods: {
        removePallet(item) {
            const index = this.palletsList.indexOf(item)

            if (this.reportId) {
                this.$store.dispatch('reports/removePallet', item.id)
                    .then(() => {
                        this.allPallets.splice(index, 1)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            } else {
                this.allPallets.splice(index, 1)
            }

            this.changedPalletList()
        },
        addPalletToList(palletNumber) {
            const alreadyExistedPallet = this.allPallets.find(pallet => pallet.parameter === palletNumber)

            if (!this.reportId) {
                if (alreadyExistedPallet) {
                    this.$store.dispatch('showNotification', {
                        type: 'primary',
                        message: 'Wprowadzony numer został już wcześniej dodany.'
                    })
                } else {
                    this.allPallets.push({'parameter': palletNumber})
                }
                this.pallet = null
            } else {
                if (alreadyExistedPallet) {
                    this.$store.dispatch('showNotification', {
                        type: 'primary',
                        message: 'Wprowadzony numer został już wcześniej dodany.'
                    })
                    this.pallet = null
                } else {
                    this.$store.dispatch('reports/addPallet', {
                        'reportId': this.reportId,
                        'parameter': palletNumber
                    })
                        .then(response => {
                            this.allPallets.push({'parameter': response.parameter, 'reportId': response.reportId, 'id': response.id})
                            this.pallet = null
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                }
            }

            this.changedPalletList()
        },
        setFocus() {
            this.$v.pallet.$reset()
            this.$refs.palletNumberField.focus()
        },
        changedPalletList() {
            this.setFocus()
            this.$emit('on-change', this.allPallets)
        }
    }
}
</script>